import React, { useState, useEffect } from 'react';
import './anasayfa.css';
import HaberlerSlider from './haberler';
import foto from '../images/newphotos/krp15.png';
import foto1 from '../images/newphotos/yeni1.png';
import foto2 from '../images/newphotos/yeni6.png';
import foto3 from '../images/newphotos/yeni15.png';
import foto4 from '../images/newphotos/yeni16.png';
import tfoto1 from '../images/gallery/triplegallery1.png';
import tfoto2 from '../images/gallery/triplegallery2.png';
import tfoto3 from '../images/gallery/triplegallery3.png';
import tfoto4 from '../images/gallery/triplegallery4.png';
import tfoto5 from '../images/gallery/triplegallery5.png';
import tfoto6 from '../images/gallery/triplegallery6.png';
import sampleImage from '../images/yorum1.jpeg';
import sampleImage2 from '../images/yorum2.jpeg';
import sampleImage3 from '../images/yorum3.jpeg';


const photos = [foto1, foto2, foto3, foto4];
const tphotos = [tfoto1, tfoto2, tfoto3, tfoto5, tfoto6];

const MainPage = () => {
    // State for tphotos gallery
    const [tcurrentIndex, setTCurrentIndex] = useState(0);

    // Function to go to the next set of 3 slides for tphotos gallery
    const nextSlide = () => {
        setTCurrentIndex((prevIndex) => (prevIndex + 3) % tphotos.length);
    };

    // Get 3 photos to display at once in tphotos gallery
    const getPhotosToDisplay = () => {
        return [
            tphotos[tcurrentIndex],
            tphotos[(tcurrentIndex + 1) % tphotos.length],
            tphotos[(tcurrentIndex + 2) % tphotos.length]
        ];
    };

    // State for photos gallery
    const [currentIndex, setCurrentIndex] = useState(0);

    // Function to go to the previous photo for photos gallery
    const prevPhoto = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + photos.length) % photos.length);
    };

    // Function to go to the next photo for photos gallery
    const nextPhoto = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % photos.length);
    };

    // useEffect to handle both photo galleries with separate intervals
    useEffect(() => {
        const photoInterval = setInterval(() => {
            nextPhoto();
        }, 5000);

        const slideInterval = setInterval(() => {
            nextSlide();
        }, 5000);

        // Cleanup both intervals on component unmount
        return () => {
            clearInterval(photoInterval);
            clearInterval(slideInterval);
        };
    }, []);
    
    return (
        <div className="mainpage">
            <div className="gallery-item">
  <div className="text-overlay">
    <h1 className="hdr">Kariyerinize Reeder ile Yön Verin</h1>
    <p className="pgrph">Teknoloji ve inovasyonun kalbinde yer almak ister misiniz? Reeder’da kariyer fırsatlarını keşfedin ve geleceğinizi bizimle inşa edin.</p>
  </div>
  <img src={foto} alt="Gallery Item" className="gallery-photo" />
  <button className="actionbutton" onClick={() => window.location.href='/ilanlar'}>İş Başvurusu Yap</button>
</div>
            <div className="gallery">
            <div className="galleryheader"><h1>Gelişim ve Eğitim - İş ve Yaşam Dengesi - Takım Ruhu ve Kültür</h1></div>
            <img src={photos[currentIndex]} alt={`Slide ${currentIndex + 1}`} className="gallery-photo" />
        </div>

        {/*<div className="headernews"><h1>Haberler</h1></div>
        <div className="triplegallery">
            {getPhotosToDisplay().map((photo, index) => (
                <img key={index} src={photo} alt={`Slide ${index + 1}`} className="triplegallery-photo" />
            ))}
        </div>*/}
        {/*<HaberlerSlider/>*/}
        
        </div>
    );
};

export default MainPage;